import { Calendar, ArrowRight, Newspaper } from 'lucide-react';
import { Link } from 'react-router-dom';

const News = () => {
  const news = [
    {
      id: 1,
      title: 'Nouvelles Réglementations ANJ 2025 : Ce Qui Change pour les Parieurs',
      date: '25.11.2025',
      excerpt: 'L\'Autorité Nationale des Jeux annonce de nouvelles mesures de protection des joueurs et des modifications importantes dans les conditions de bonus.',
      link: '/news/nouvelles-reglementations-anj-2025',
    },
    {
      id: 2,
      title: 'Comparatif des Meilleurs Bonus de Bienvenue : Notre Analyse 2025',
      date: '24.11.2025',
      excerpt: 'Nous avons analysé en détail les offres promotionnelles des principales plateformes pour vous aider à choisir le bonus le plus avantageux.',
      link: '/news/comparatif-bonus-bienvenue-2025',
    },
    {
      id: 3,
      title: 'Tendances des Paris Sportifs en France : Football et Tennis en Tête',
      date: '23.11.2025',
      excerpt: 'Analyse des habitudes de paris des Français en 2025. Le football reste le sport le plus parié, suivi de près par le tennis et les courses hippiques.',
      link: '/news/tendances-paris-sportifs-2025',
    },
  ];

  return (
    <section id="actualites" className="py-20 bg-gradient-to-br from-dark-card to-dark-bg">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <Newspaper className="w-12 h-12 text-toxic-green" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Actualités & <span className="text-toxic-green">Analyses</span>
          </h2>
          <p className="text-xl text-gray-400">
            Restez informé des dernières tendances et actualités du secteur
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {news.map((item, index) => (
            <article
              key={item.id}
              itemScope
              itemType="http://schema.org/NewsArticle"
              className={`bg-dark-bg border-2 border-gray-800 rounded-2xl overflow-hidden hover:border-toxic-green transition-all transform hover:scale-105 ${
                index === 0 ? 'md:col-span-1' : ''
              }`}
            >
              {/* News image */}
              <div className="h-48 relative overflow-hidden">
                <img 
                  src={`/images/${index === 0 ? 'robert-katzki-APZWYETwgp0-unsplash.webp' : index === 1 ? 'max-titov-xtRWIviknsw-unsplash.webp' : 'waldemar-brandt-iiwYpGkbDgM-unsplash.webp'}`}
                  alt={item.title}
                  itemProp="image"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-bg via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4 z-10">
                  <div className="flex items-center text-sm text-gray-300 bg-dark-bg/80 px-3 py-1 rounded-full">
                    <Calendar className="w-4 h-4 mr-2 text-toxic-green" />
                    <time dateTime={item.date.split('.').reverse().join('-')} itemProp="datePublished">{item.date}</time>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-white line-clamp-2" itemProp="headline">
                  {item.title}
                </h3>
                <p className="text-gray-400 mb-4 leading-relaxed line-clamp-3" itemProp="description">
                  {item.excerpt}
                </p>
                <Link
                  to={item.link}
                  data-discover="true"
                  itemProp="url"
                  className="inline-flex items-center text-toxic-green font-semibold hover:text-opacity-80 transition-colors group"
                >
                  Lire la suite
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;

